import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function BellIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        viewBox="0 0 506 617"
        {...props}
      >
        <path
          fillRule="evenodd"
          d="M480.56 417.49c20.88 19.51 33.29 45.51 17 69.51-6.45 9.5-15.63 13.48-20.5 15-6.17 1.93-14.71 1.77-24.26 1.6-2.91-.06-5.82-.1-8.74-.1-45.64 0-100.97.1-100.97.1 0 74.89-48.53 113.39-91.26 113.39S159.5 577 163.58 503.6c0 0-78.28.12-118.52.4-24.5.17-34.29-11-38.5-17.5-6.47-10-16.5-36.5 17.5-69.5 10-9.71 28.5-48 28.5-76.01 0-21.12.13-35.94.25-50.64.12-14.45.25-28.78.25-48.85 0-16.01 4.8-35 10-51.01 32.5-100 124.5-124.99 124.5-124.99 0-44.5 33.5-65.5 65-65.5s63.5 20 65 65.5c0 0 91 25.5 125 124.99 4.49 13.15 8.09 32.11 9.5 51.51v105.99c0 33 5 47.54 28.5 69.5M448 455.99H58S86 423.5 96.5 381c8.21-33.23 7.37-62.45 6.58-90-.51-17.64-1-34.6.92-51.5 12.51-110.17 108.61-129.89 131.62-134.61.7-.14 1.32-.27 1.88-.39V62c0-3 3.5-12 15-12s15.02 7 15.5 12c1 10.5 1 26.5 1 42.5 34 5.5 129.44 36 134 147 1.34 32.55.8 52.97.37 69.56-.54 20.61-.93 35.29 2.63 59.94 7 48.5 42 74.99 42 74.99M218 536h75c-4.11 15.22-16.44 34-35.45 34-26.71 0-37.5-19.79-39.55-34"
          clipRule="evenodd"
        />
      </svg>
    </Icon>
  )
}
export default BellIcon
